export class Group {
    constructor(figures) {
        this.getFigures = () => this.figures;
        this.getLeftExtension = () => this.getLeftFigures().map(f => f.copyLeft());
        this.getRightExtension = () => this.getRightFigures().map(f => f.copyRight());
        this.getTopExtension = () => this.getTopFigures().map(f => f.copyTop());
        this.getBottomExtension = () => this.getBottomFigures().map(f => f.copyBottom());
        this.sortFiguresXMin = () => this.figures.sort((a, b) => a.getXMin() - b.getXMin());
        this.sortFiguresXMax = () => this.figures.sort((a, b) => b.getXMax() - a.getXMax());
        this.sortFiguresYMin = () => this.figures.sort((a, b) => a.getYMin() - b.getYMin());
        this.sortFiguresYMax = () => this.figures.sort((a, b) => b.getYMax() - a.getYMax());
        this.figures = figures ? figures : new Array();
    }
    getXMax() {
        return Math.max(...this.figures.map(f => f.getXMax()));
    }
    ;
    getXMin() {
        return Math.min(...this.figures.map(f => f.getXMin()));
    }
    getYMax() {
        return Math.max(...this.figures.map(f => f.getYMax()));
    }
    getYMin() {
        return Math.min(...this.figures.map(f => f.getYMin()));
    }
    addFigure(figure) {
        this.figures.push(figure);
    }
    addFigures(figures) {
        this.figures = this.figures.concat(figures);
    }
    getBottomLeftFigure() {
        return this.figures.sort((a, b) => a.getYMin() - b.getYMin() + (a.getXMin() - b.getXMin()))[0];
    }
    getBottomRightFigure() {
        return this.figures.sort((a, b) => a.getYMin() - b.getYMin() + (b.getXMin() - a.getXMin()))[0];
    }
    getTopLeftFigure() {
        return this.figures.sort((a, b) => b.getYMin() - a.getYMin() + (a.getXMin() - b.getXMin()))[0];
    }
    getTopRightFigure() {
        return this.figures.sort((a, b) => b.getYMin() - a.getYMin() + (b.getXMin() - a.getXMin()))[0];
    }
    getLeftFigures() {
        const xMinSortedFigures = this.sortFiguresXMin();
        return xMinSortedFigures.filter(f => f.getXMin() === xMinSortedFigures[0].getXMin());
    }
    getRightFigures() {
        const xMaxSortedFigures = this.sortFiguresXMax();
        return xMaxSortedFigures.filter(f => f.getXMax() === xMaxSortedFigures[0].getXMax());
    }
    getTopFigures() {
        const yMaxSortedFigures = this.sortFiguresYMax();
        return yMaxSortedFigures.filter(f => f.getYMax() === yMaxSortedFigures[0].getYMax());
    }
    getBottomFigures() {
        const yMinSortedFigures = this.sortFiguresYMin();
        return yMinSortedFigures.filter(f => f.getYMin() === yMinSortedFigures[0].getYMin());
    }
}
